<template>
  <el-dialog
    :title="dialogTitle"
    :visible="true"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(false)
      }
    "
  >
    <el-form ref="form" :model="form" label-width="150px">
      <el-form-item label="轮播图名称" required>
        <el-input
          size="small"
          v-model="form.pictureName"
          placeholder="请输入轮播图名称"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="轮播图" required>
        <div class="img-control">
          <div class="img-box" v-if="form.pictureUrl">
            <img :src="form.pictureUrl" alt="轮播图" />
            <span class="clear-img" @click="handleClearImg">X</span>
          </div>
          <Upload ref="uploadRef" :text="'，图片尺寸为806*447px'" v-model="form.pictureUrl" />
        </div>
      </el-form-item>
      <el-form-item label="链接地址">
        <el-input
          size="small"
          v-model="form.pictureLink"
          placeholder="请输入链接地址"
          maxlength="200"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序号">
        <div class="flex">
          <el-input
            size="small"
            v-model="form.sortNum"
            placeholder="请输入排序号"
            @input="sortNumChange"
          ></el-input>
          <el-tooltip
            effect="dark"
            content="前端展示按照排序号由大到小顺序排列"
            placement="top-start"
          >
            <img src="../../assets/images/doubt.png" alt="提示" />
          </el-tooltip>
        </div>
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button class="search-but1" size="small" @click="handleClose(false)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import Upload from '../informationManage/module/upload.vue'
import * as API from '../../api/swipers/index'
export default {
  props: ['dialogTitle', 'handleClose', 'defaultData'],
  name: 'SwiperWrite',
  components: { Upload },
  data() {
    return {
      form: {
        ...this.defaultData
      }
    }
  },
  methods: {
    sortNumChange(value) {
      if (value && !(value > 0)) this.$set(this.form, 'sortNum', '')
    },
    handleClearImg() {
      this.form.pictureUrl = ''
    },
    async handleSubmit() {
      const { form, dialogTitle } = this
      const { pictureName, pictureUrl, sortNum } = form
      if (!(pictureName && pictureUrl)) {
        this.$message.warning('请填写必填项，再继续保存')
        return
      }
      try {
        const data = {
          ...form,
          sortNum: sortNum ? Number(sortNum) : 1
        }
        const res = await API[
          dialogTitle === '新建轮播图' ? 'addSwiper' : 'updateSwiper'
        ](data)
        const { code } = res
        if (code === 0) {
          this.$message.success('保存成功')
          this.handleClose(dialogTitle === '新建轮播图' ? 'reset' : 'update')
        }
      } catch (error) {}
    }
  }
}
</script>
<style lang="scss" scoped>
.img-control {
  display: flex;
  .img-box {
    position: relative;
    margin-right: 10px;
    > img {
      width: 360px;
      height: 180px;
    }
    .clear-img {
      position: absolute;
      top: 0;
      right: 0;
      display: block;
      border: 1px solid #333;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.flex {
  display: flex;
}
.write-footer {
  text-align: right;
}
</style>
